import { render, staticRenderFns } from "./pay.vue?vue&type=template&id=f89b5200&scoped=true&"
import script from "./pay.vue?vue&type=script&lang=js&"
export * from "./pay.vue?vue&type=script&lang=js&"
import style0 from "./pay.vue?vue&type=style&index=0&id=f89b5200&prod&scoped=true&lang=css&"
import style1 from "./pay.vue?vue&type=style&index=1&id=f89b5200&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f89b5200",
  null
  
)

export default component.exports